module.exports = __webpack_public_path__ + "static/Rosewater1-c1b04e843004eae0b6a4595f01143a1f.png";